import {store} from '../../redux/ROOT'
import {
  actionGetCurriculums,
  actionGetGetGradeLevels, actionGetStudents, actionSetLastCacheTime
} from "../../redux/education";
import { actionGetAvatars } from "../../redux/content";
import moment from "moment";
import { actionGetCategories, actionGetStories } from "../../redux/education/actions/story.action";
import { actionGetStoryQuestionGroups } from "../../redux/question";

export function globalDataCache() {
  console.log('cache check 1')
  let authData = store.getState().authReducer.authentication.token
  if (!authData) return;
  let cacheCheck = getCacheCheck();
  let selectedClassroom = store.getState().educationReducer.classroom
  store.dispatch(actionGetGetGradeLevels());
  if (!selectedClassroom) {
  store.dispatch(actionGetStudents({classroomId:selectedClassroom.id}))
  }
  store.dispatch(actionGetAvatars({}));
  console.log('cache check')
  store.dispatch(actionGetStories({languageCode:"tr-TR"}, (response) => {
    console.log('actionGetStories response:', response)
  }))
  console.log('actionGetStories dispatched')
  store.dispatch(actionGetCurriculums({languageCode:"tr-TR"}))
  store.dispatch(actionGetCategories({languageCode:"tr-TR",categoryTypeId:4}))
  store.dispatch(actionGetStoryQuestionGroups({}))
  store.dispatch(actionSetLastCacheTime())
}

function getCacheCheck(){
  let lastRequestDate = store.getState().educationReducer.lastRequestDate
  if (lastRequestDate === null || lastRequestDate == null) return true
  let currentDate = moment().utc().toDate()
  let lastRequestDateMom = moment(lastRequestDate.toString()).utc().toDate()
  let diff = moment(currentDate).diff(lastRequestDateMom, 'minutes')
  return diff >= 60;
}
